import {useEffect, useState} from "react";
import styles from './style.module.scss';
import Step1 from "./components/steps/step1";
import Step2 from "./components/steps/step2";
import Step3 from "./components/steps/step3";
import Step4 from "./components/steps/step4";
import Step5 from "./components/steps/step5";
import Step6 from "./components/steps/step6";
import useStore from "./store/store";
import {host} from "./const/const";
import Summary from "./components/summary/summary";
import Step7 from "./components/steps/step7";
if (process.env.NODE_ENV === 'development') {
    import('./global.css').then((module) => {
        // Используйте module
    });
}

console.log(process.env)
function getId(metaName) {
    let elem = document.getElementById('order-form')
    if (elem) {
        return elem.dataset.id;
    }
    return null;
}

Date.prototype.addHours = function (h) {
    this.setHours(this.getHours() + h);
    return this;
}
Date.prototype.addDays = function (days) {
    let date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

function App() {
    const [loading, setLoading] = useState(true);
    const [calcData, setCalcData] = useState(null)
    const setCurrentDate = useStore((state) => state.setCurrentDate)
    const setCarId = useStore((state) => state.setCarId)
    const setAvailableMode = useStore((state) => state.setAvailableMode)
    const setSummaryHead = useStore((state) => state.setSummaryHead)
    const setUser = useStore((state) => state.setUser)
    const setUserName = useStore((state) => state.setUserName)
    const setUserTel = useStore((state) => state.setUserTel)
    const getApiData = async (carId) => {
        try {
            const response = await fetch(
                `${host}?action=get_car_calc_data&id=${carId}`
            ).then((response) => response.json());
            setCalcData(response);
            setLoading(false);
            if (response?.available) {
                setAvailableMode(response.available)
            }
            if (response?.user) {
                setUser(response.user)
                if (!!response?.user?.fio) {
                    setUserName(response.user.fio)
                }
                if (response?.user?.tel) {
                    setUserTel(response.user.tel)
                }
            }
            if (response?.summaryHead) {
                setSummaryHead(response.summaryHead)
            }
        } catch (error) {
            console.error(error.message);
        }
    };
    useEffect(() => {
        const carId = getId();
        if (carId > 0) {
            setCarId(carId);
            getApiData(carId);
        }
        setCurrentDate(new Date().addHours(3))
    }, []);
    if (loading) {
        return (<div>Загрузка</div>)
    }
    return (
        <div className={styles.newOrder}>
            <div className={styles.newOrder__content}>
                <Step1 number={1} minRentDays={calcData?.minRentDays || 1}/>
                <Step2 number={2}
                       rates={calcData?.rates || []}
                       promoFinishDate={calcData?.price_data?.promo?.finish_date || null}
                       promoPriceGrid={calcData?.price_data?.promo?.grid || null}
                       priceGrid={calcData?.price_data?.grid || null}
                       links={calcData?.links || null}
                />
                <Step3 number={3} insurances={calcData?.insurances || null} links={calcData?.links || null}/>
                <Step4 number={4} services={calcData?.services || null}/>
                <Step5 number={5} services={calcData?.services || null}/>
                <Step6 number={6} services={calcData?.services || null}/>
                <Step7 number={7}/>
            </div>
            <aside className={styles.newOrder__aside}>
                <Summary
                    rates={calcData?.rates || []}
                    car={calcData?.car || null}
                    insurances={calcData?.insurances || null}
                    services={calcData?.services || null}
                    promoFinishDate={calcData?.price_data?.promo?.finish_date || null}
                    promoPriceGrid={calcData?.price_data?.promo?.grid || null}
                    priceGrid={calcData?.price_data?.grid || null}
                    links={calcData?.links || null}
                />
            </aside>
        </div>
    );
}

export default App;
